import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useTranslation } from 'utils/modifiedTranslation';
import app from 'new-ui/app';
import { ReactComponent as ClockIcon } from '../../assets/icons/light_clock.svg';
import { ReactComponent as MegaphoneIcon } from '../../assets/icons/cheering_megaphone.svg';
import { ARTICLES_GA } from '../../constants';
import { ArticleLazyImage } from '../ArticleLazyImage/ArticleLazyImage';
import styles from './articleCard.module.css';

export const CARD_THEMES = {
  secondary: styles.secondary,
};

export const ArticleCard = forwardRef(({
  item, selectedTags, onClick, theme,
}, ref) => {
  const { t } = useTranslation();
  return (
    <div
      ref={ref}
      className={cx(styles.root, theme)}
      onClick={() => {
        app.sendGoogleAnalyticsEvent(ARTICLES_GA.category, ARTICLES_GA.events.articleCardClick, {
          article_title: item.title,
          article_link: item.sourceUrl,
          tag_label: item.tag,
          duration: item.durationMinutes,
          urgency_level: item.urgency,
        });
        onClick();
      }}
    >
      <div className={styles.imageContainer}>
        <div className={styles.imageWrapper}>
          <ArticleLazyImage src={item.imageUrl} alt={item.title} />
        </div>
        <div className={cx(styles.tag, { [styles.selectedTag]: selectedTags.includes(item.key) })}>
          {item.tag}
        </div>
      </div>
      <h3 className={styles.title}>
        {item.title}
      </h3>
      <div className={styles.duration}>
        <div className={styles.key}>
          <ClockIcon />
          {t('articles.card.duration')}
        </div>
        <span className={styles.value}>
          {`${item.durationMinutes} ${t('articles.card.minutes')}`}
        </span>
      </div>
      <div className={styles.urgency}>
        <div className={styles.key}>
          <MegaphoneIcon />
          {t('articles.card.urgency')}
        </div>
        <span className={styles.value}>
          {item.urgency}
        </span>
      </div>
      <div className={styles.description}>
        {item.briefContent}
      </div>
    </div>
  );
});

ArticleCard.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    urgency: PropTypes.string.isRequired,
    tag: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    sourceUrl: PropTypes.string.isRequired,
    briefContent: PropTypes.string.isRequired,
    durationMinutes: PropTypes.number.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  selectedTags: PropTypes.array.isRequired,
  theme: PropTypes.oneOf(Object.values(CARD_THEMES)),
};
